import { REACT_APP_ARPS_BASE_URL } from "../utils/urls";

const saveSocial = async (data: any, customer_id: string) => {
  const response = await fetch(`${REACT_APP_ARPS_BASE_URL}/socials`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  const result = await response.json();
  return result;
};

export default saveSocial;
